import { render, staticRenderFns } from "./indexCatalog.vue?vue&type=template&id=21a665fe"
import script from "./indexCatalog.vue?vue&type=script&lang=js"
export * from "./indexCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports